import {
  EDITA_TURNOSDISPONIBLES,
  FINALIZA_TURNOSDISPONIBLES,
  RESET_FILTROSDISPONIBLES,
  SET_FECHA_TURNOS,
  SET_TURNOS_DATA,
} from "../../ActionTypes";

export const editaTurnosDisponibles = (data) => (dispatch) => {
  dispatch({
    type: EDITA_TURNOSDISPONIBLES,
    payload: data,
  });
};

export const editaTurnosDisponiblesPush = (data) => (dispatch) => {
  return new Promise((resolve) => {
    dispatch({
      type: EDITA_TURNOSDISPONIBLES,
      payload: data,
    });
    resolve(); // Confirma que el dispatch se completó
  });
};

export const resetFiltrosDisponibles = () => (dispatch) => {
  dispatch({
    type: RESET_FILTROSDISPONIBLES,
  });
};

export const finalizaTurnosDisponibles = () => (dispatch) => {
  dispatch({
    type: FINALIZA_TURNOSDISPONIBLES,
  });
};

export const setFechaTurno = (fecha) => (dispatch) => {
  dispatch({ type: SET_FECHA_TURNOS, payload: fecha });
};
